export default "__VITE_PUBLIC_ASSET__9fe372fc__"